// @ts-nocheck
import React from "react";
import SheetPageContainer from "./SheetPageContainer";

export default function PaymentSheetPage(props: { tokenOverride?: string; embedded?: boolean }) {
  return <SheetPageContainer scope="payment" tokenOverride={props.tokenOverride} embedded={props.embedded} />;
}
